import React, { useState, useEffect } from "react";
import "./SkillOrea_LP.css";
import SkilloreaHomeslider from "./SkilloreaHomeslider";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";

const SkillOrea_LP = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const meta = metaConfig.skillorea;

  // Toggle the sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [images, setImages] = useState([
    "assets/img/skillorea/leader1.png",
    "assets/img/skillorea/leader2.png",
    "assets/img/skillorea/leader3.png",
    "assets/img/skillorea/leader4.png",
    "assets/img/skillorea/leader5.png",
    "assets/img/skillorea/leader6.png",
    "assets/img/skillorea/leader7.png",
    "assets/img/skillorea/leader8.png",
  ]);

  // Function to shuffle images
  const shuffleImages = () => {
    const shuffled = [...images];
    // Move a random image to a random index
    const randomIndex1 = Math.floor(Math.random() * shuffled.length);
    const randomIndex2 = Math.floor(Math.random() * shuffled.length);

    const temp = shuffled[randomIndex1];
    shuffled[randomIndex1] = shuffled[randomIndex2];
    shuffled[randomIndex2] = temp;

    setImages(shuffled);
  };

  // Scroll event handler
  const handleScroll = () => {
    // Detect how far the user has scrolled
    const scrollPosition = window.scrollY;

    // If the user has scrolled a certain amount, shuffle the images
    if (scrollPosition > 10) {
      shuffleImages();
    }
  };

  // Set up scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const Mobilescreens = [
    "assets/img/skillorea/screen1.png",
    "assets/img/skillorea/screen2.png",
    "assets/img/skillorea/screen3.png",
    "assets/img/skillorea/screen3.png",
    "assets/img/skillorea/screen4.png",
    "assets/img/skillorea/screen5.png",
    "assets/img/skillorea/screen6.png",
    "assets/img/skillorea/screen7.png",
    "assets/img/skillorea/screen8.png",
    "assets/img/skillorea/screen9.png",
    "assets/img/skillorea/screen10.png",
  ];

  return (
    <div className="bg_green_orea">
      <SEO {...meta} />
      <div className="main_orea">
        <div className="container-fluid  position-relative p-0">
          <div className="mt-0 mainheader">
            <div className="patternwrap "></div>
            <div className="col-11 mx-auto item-align-end">
              <nav className="navbar py-3">
                <div className="logo">
                  <a href="https://skillorea.com/" className="p-0">
                    <img
                      src="assets/img/skillorea/skillorea.svg"
                      alt="skillorea"
                    />
                  </a>
                </div>

                <div className="head_orea_left d-flex">
                  <div className="logwrap d-flex">
                    <a
                      href="https://skillorea.test.ktig.info/"
                      className="pe-2"
                    >
                      <div className="m-auto">
                        {" "}
                        <img
                          src="assets/img/skillorea/thumb.svg"
                          alt="skillorea"
                        />
                      </div>
                      Login
                    </a>
                  </div>
                  <span></span>
                  <div className="callwrap">
                    <p className="m-0">Available on Call 24x7</p>
                    <a href="tel:+91 9940506090" className="pe-2 ">
                      +91 99&ensp;40&ensp;506090
                    </a>
                  </div>
                </div>
              </nav>
            </div>

            <div className="container-fluid p-0  mt-0">
              <div
                className="text-center mt-0 mx-auto wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="oreawrap">
                  <SkilloreaHomeslider />
                </div>
              </div>
            </div>
          </div>

          <div class=" d-xl-flex me-3">
            {isSidebarOpen && (
              <div className="left-sidebar">
                <div className="social-icons">
                  <a
                    href="https://www.facebook.com/skillorea"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/@Skillorea"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/skill_orea/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/skillorea/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="container-fluid  position-relative p-0">
          <div className="oreacourse mt-5">
            <div className="container py-5" data-wow-delay="0.2s">
              <h3
                className="text-center pb-2 mx-auto wow fadeInUp"
                data-wow-delay="0.2s"
              >
                An Innovative Course <br /> For Students
              </h3>
              <div className="oreacourse_wrap col-md-12 m-auto d-flex">
                <div className="col-md-6 wow fadeInLeft" data-wow-delay="0.2s">
                  <div className="orea_pro_patternleft"></div>
                  <div className="orea_pro_pattern">
                    <div className="orea_pro_item">
                      <img
                        src="assets/img/skillorea/appdashboard_phone.png"
                        alt="appdashboard"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 orea_pro_item_details wow fadeInRight"
                  data-wow-delay="0.3s"
                >
                  <div className="col-md-8">
                    <h6>Health Wellness Program</h6>
                    <p>
                      Nurture your child's health with SkillOrea. We offer fun
                      activities and expert medical support.
                    </p>
                    <ul className="m-0 pb-3">
                      <li>Diverse games and sports</li>
                      <li>Engaging arts and dance </li>
                      <li>24/7 online doctor access</li>
                      <li>All-around child growth</li>
                    </ul>
                  </div>
                  <div className="col-md-8">
                    <h6>Premium Home Tuition</h6>
                    <p>
                      Skillorea's Premium Tuition combines self-paced study with
                      live expert classes for maximum learning
                    </p>
                    <ul className="m-0 pb-3">
                      <li>Interactive self-learning </li>
                      <li>Unlimited retests for mastery </li>
                      <li>Live doubt-clearing session</li>
                    </ul>
                  </div>
                  <div className="col-md-8">
                    <h6>Next Gen Project Guidance </h6>
                    <p>
                      Gain hands-on skills and collaborate in real teams to
                      build projects for future success.
                    </p>
                    <ul className="m-0 pb-3">
                      <li>Work on real-world projects </li>
                      <li>
                        Develop essential teamwork skills and communication
                        skills{" "}
                      </li>
                      <li>Instant QA support for clarity and confidence.</li>
                    </ul>
                  </div>

                  <div className="orea_btn">
                    <div className="cta">
                      <a href="https://skillorea.com/" alt="Explore Courses">
                        Explore Courses
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid  position-relative p-0">
          <div className="wallcurv"></div>
        </div>
        <div className="container-fluid  py-5">
          <div className="aboutorea container text-center">
            <h3
              className="text-center m-0 pb-3 mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
            >
              Why Choose <span className="orea_orange">Skill</span>
              <span className="orea_green">orea</span>?
            </h3>
            <p className="blog_titleintro">
              Get diverse skills, AI learning, and whole wellness
            </p>

            <div className="orea_tutorboard">
              <div>
                <div
                  className="images"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {images.map((image, index) => (
                    <div
                      key={index}
                      className="image-container"
                      style={{
                        margin: "10px",
                        transition: "transform 1s ease",
                      }}
                    >
                      <img
                        src={image}
                        alt={`Image ${index + 1}`}
                        style={{
                          width: "200px",
                          height: "200px",
                          transition: "transform 1s ease", // Smooth transition on transform
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="blog_details col-md-10 m-auto">
              <p className="">
                Skillorea makes learning with the introduction of personalized
                AI characters. Imagine your educational journey guided by your
                favourite cartoon heroes. It's like having a virtual learning
                buddy who makes even the toughest topics exciting and fun.
                Skillorea uses these AI characters to transform learning from a
                chore into an adventure. This approach makes learning incredibly
                interesting and interactive, sparking a natural curiosity and
                actively involved.
              </p>
              <div className="orea_btn p-2 m-2">
                <div className="cta m-2">
                  <a href="https://skillorea.com/" alt="Download Now">
                    Download Now
                  </a>
                </div>
                <div className="cta">
                  <a href="https://skillorea.com/" alt="Start Learning">
                    Start Learning Today
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid p-0">
          <div className="orea_mobilslider">
            <div className="slider-container">
              <div className="slider">
                <div className="slider-track">
                  {/* First Loop (Original Images) */}
                  {Mobilescreens.map((image, index) => (
                    <div className="slide" key={index}>
                      <img src={image} alt={`Slide ${index + 1}`} />
                    </div>
                  ))}
                  {/* Second Loop (Same Images to Create Continuity) */}
                  {Mobilescreens.map((image, index) => (
                    <div className="slide" key={`copy-${index}`}>
                      <img src={image} alt={`Slide ${index + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="blog_details text-center pt-5 col-md-10 m-auto">
            <p className=" p-4">
              Skillorea understands that when learning is enjoyable, students
              are more motivated and remember what they learn more effectively.
              That's why our platform harnesses the power of AI to create
              engaging and personalized learning experiences. These AI
              companions act as guides and mentors, adapting to each kid's
              unique learning pace and style. They provide support,
              encouragement, and a sense of fun, making learning less stressful
              and more rewarding. Skillorea believes that every child deserves
              to discover the joy of learning, and our AI characters are here to
              make that possible.
            </p>
            <h3
              className="text-center m-0 py-3 mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
            >
              Super-fun & Interactive <br /> Learning Activities
            </h3>
            <div className="col-md-12 pt-3 orea_activities">
              <div className="orea_activities justify-content-center d-flex">
                <div className="col-md-2 text-center">
                  <div className="orea_btn m-2">
                    <div className="cta m-2">
                      <a href="https://skillorea.com/" alt="Download Now">
                        Wellness
                      </a>
                    </div>
                  </div>
                  <div className="student_act p-2">
                    <img
                      src="assets/img/skillorea/act3.jpg"
                      alt="student_act"
                    />
                  </div>
                </div>
                <div className="col-md-2 text-center">
                  <div className="orea_btn m-2">
                    <div className="cta m-2">
                      <a href="https://skillorea.com/" alt="Download Now">
                        Guidance
                      </a>
                    </div>
                  </div>
                  <div className="student_act p-2">
                    <img
                      src="assets/img/skillorea/act4.jpg"
                      alt="student_act"
                    />
                  </div>
                </div>
                <div className="col-md-2 text-center">
                  <div className="orea_btn m-2">
                    <div className="cta m-2">
                      <a href="https://skillorea.com/" alt="Download Now">
                        Games
                      </a>
                    </div>
                  </div>
                  <div className="student_act p-2">
                    <img
                      src="assets/img/skillorea/act1.jpg"
                      alt="student_act"
                    />
                  </div>
                </div>
                <div className="col-md-2 text-center">
                  <div className="orea_btn m-2">
                    <div className="cta m-2">
                      <a href="https://skillorea.com/" alt="Download Now">
                        Learning
                      </a>
                    </div>
                  </div>
                  <div className="student_act p-2">
                    <img
                      src="assets/img/skillorea/act2.jpg"
                      alt="student_act"
                    />
                  </div>
                </div>
                <div className="col-md-2 text-center">
                  <div className="orea_btn m-2">
                    <div className="cta m-2">
                      <a href="https://skillorea.com/" alt="Download Now">
                        Creative
                      </a>
                    </div>
                  </div>
                  <div className="student_act p-2">
                    <img
                      src="assets/img/skillorea/act5.jpg"
                      alt="student_act"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 orea_actmobile justify-content-center">
                <div className="mobile_act">
                  <img
                    className="d-block w-100"
                    src="assets/img/skillorea/actmobile.png"
                    alt="student_act"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid  position-relative p-0">
          <div className="orea_footerdetails mt-5 p-5 text-center ">
            <div className="orea_footermobile mt-5 text-center ">
              <div className="orea_footermobile_innner text-center ">
                <p className="m-0 text-white">Download Now</p>
                <h5 className="text-center text-white m-0 p-0">
                  Skillorea Available on
                </h5>
                <div className="footer_orea_btn p-2 m-2">
                  <div className="cta m-2">
                    <a href="https://skillorea.com/" alt="Download Now">
                      <img
                        src="assets/img/skillorea/playstore.png"
                        alt="appdownload"
                      />
                    </a>
                  </div>
                  <div className="cta m-2">
                    <a href="https://skillorea.com/" alt="Start Learning">
                      <img
                        src="assets/img/skillorea/appstore.png"
                        alt="appdownload"
                      />
                    </a>
                  </div>
                  <div className="cta m-2">
                    <a href="https://skillorea.com/" alt="Start Learning">
                      <img
                        src="assets/img/skillorea/gotolive.png"
                        alt="gotolive"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="orea_footermain mt-5 text-center col-md-6 m-auto">
              <div className="logo m-auto">
                <a href="https://skillorea.com/" className="p-0">
                  <img
                    src="assets/img/skillorea/footerlogo.svg"
                    alt="skillorea"
                  />
                </a>
              </div>
              <ul className="d-flex m-auto text-center decoration-none">
                <li>
                  <a href="https://skillorea.com/about">About Us</a>
                </li>
                <li>
                  <a href="https://skillorea.com/wellness">Wellness</a>
                </li>
                <li>
                  <a href="https://skillorea.com/shop">Shop</a>
                </li>
                <li>
                  <a href="https://skillorea.com/oncall">On Call</a>
                </li>
                <li>
                  <a href="https://skillorea.com/contact">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="orea_footer_pattern text-center">
            <p className=" text-white mb-0">© 2025 All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillOrea_LP;
